// extracted by mini-css-extract-plugin
export default {"root":"badge_icon-module___root___e4a56f5c","valueContainer":"badge_icon-module___valueContainer___ccc7485f","value":"badge_icon-module___value___c83a940b"};